mutation SetRingCentralIntegrationIsEnabled($isEnabled: Boolean!) {
    setRingCentralIntegrationIsEnabled(input: {isEnabled: $isEnabled}) {
        authUrl
    }
}
